export default "__VITE_ASSET__fd093cd0__"